export default "__VITE_ASSET__fb45cc99__"